export default __webpack_public_path__ + "static/bc_hu_2-e6585b62258733ab46281f33e387075c.mp4";